var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-dropdown-item",
    {
      staticClass: "card-dropdown-item",
      attrs: { disabled: this.app.status === "UNINSTALLED" },
      on: {
        click: function() {
          return _vm.handleMonitoringIntegrationButton()
        }
      }
    },
    [
      _c(
        "span",
        [
          _c("sc-icon", { attrs: { icon: "heartbeat" } }),
          _vm._v(" Monitorar ")
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd155bd8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd155bd8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/components/app-list/app-card/header-card/menu-card/monitor-button/MonitorButton.vue
// module id = null
// module chunks = 